export const LOADING_IN_PROGRESS_ERROR = 'manage service loading in progress';
